import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import SearchResults from "@/pages/SearchResults";
import VehicleDetail from "@/pages/VehicleDetail";
import About from "@/pages/About";
import { AuthProvider } from "@/contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/search/:vin" element={<SearchResults />} />
          <Route path="/vin/:vin" element={<VehicleDetail />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;